import MaterialFormControl from "../../../../../__snowpack__/pkg/@mui/material/FormControl.js";
import MaterialSelect from "../../../../../__snowpack__/pkg/@mui/material/Select.js";
import styled from "styled-components";
export const SelectContainer = styled(MaterialSelect).withConfig({
  displayName: "selectstyles__SelectContainer",
  componentId: "sc-18y18zv-0"
})([""]);
export const MaterialFormControlContainer = styled(MaterialFormControl).withConfig({
  displayName: "selectstyles__MaterialFormControlContainer",
  componentId: "sc-18y18zv-1"
})(["min-width:10rem;"]);
